import { User } from '../../user/user.model';

// this might move
// for now do not extend parent ScorecardTab from this interface
export interface ScorecardTabShallow {
    tabId: string;
    tabLabel: string;
    userId: number;
    user: User;
    displayOrder: number;
    pending: boolean;
    hasData: boolean;
    managerName: string;
    numberOfDays: number;
    siteName: string;
    periodStartDate: Date;
    periodEndDate: Date;
    isManager: boolean; // TODO revise
}

export interface ScorecardHeaderState {
    tabs?: ScorecardTabShallow[];
    selectedTab?: ScorecardTabShallow;

    /** pop-up/modal */
    userSelectOpts: {
        open?: boolean;

        /**
         * when open=true: pre-selected user when user-select component opens
         * when open=false: user that was selected, if any
         */
        userId?: number;

        user?: User;
    };
}

export const defaultScorecardHeaderState = (): ScorecardHeaderState => ({
    userSelectOpts: {},
});
